import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Typography,
  Box,
  Divider,
  Tabs,
  Tab,
} from '@mui/material';
import {
  Close as CloseIcon,
  Description as DescriptionIcon,
  CreditCard as CreditCardIcon,
} from '@mui/icons-material';
import WritingTemplatesSettings from './WritingTemplatesSettings';
import BillingSettings from './BillingSettings';

interface SettingsModalProps {
  open: boolean;
  onClose: () => void;
}

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel({ children, value, index }: TabPanelProps) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`settings-tabpanel-${index}`}
      aria-labelledby={`settings-tab-${index}`}
    >
      {value === index && <Box sx={{ pt: 3 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `settings-tab-${index}`,
    'aria-controls': `settings-tabpanel-${index}`,
  };
}

const SettingsModal: React.FC<SettingsModalProps> = ({ open, onClose }) => {
  const [tab, setTab] = useState(0);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Typography variant="h6">Settings</Typography>
        <IconButton onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <Divider />

      <Box sx={{ px: 3, pt: 1 }}>
        <Tabs value={tab} onChange={(_, next) => setTab(next)}>
          <Tab icon={<DescriptionIcon />} iconPosition="start" label="Templates" {...a11yProps(0)} />
          <Tab icon={<CreditCardIcon />} iconPosition="start" label="Billing" {...a11yProps(1)} />
        </Tabs>
      </Box>

      <Divider />

      <DialogContent sx={{ p: 3 }}>
        <Box sx={{ minHeight: 400 }}>
          <TabPanel value={tab} index={0}>
            <WritingTemplatesSettings onClose={onClose} />
          </TabPanel>
          <TabPanel value={tab} index={1}>
            <BillingSettings />
          </TabPanel>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default SettingsModal;
